import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import styles from './ButtonLoginSubmit.module.scss'

const ButtonLoginSubmit = () => {

  return (
    <div className={styles.buttonLoginContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'login-button-login'}
            defaultMessage={'Login'}
          />
        )}
        customClassnames={{container: styles.button}}
      />
    </div>
  );
};

export default ButtonLoginSubmit;
